import { cooDashboardSourceHtml } from '../fixtures/cooDashboardSource';
import { parseCooSourceHtml } from '../utils/parseCooSourceHtml';

const cooDashboardData = parseCooSourceHtml(cooDashboardSourceHtml);

export default cooDashboardData;
